import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import {
  ForgotPassword,
  Maintenance,
  RegisterCertificateAccountant,
  listClientsAccountant,
  EditClientsAccountant,
  HomeAccountant,

} from "@pages";

import NewLogin from "../views/Auth/Login"
import Register from "../views/Auth/Register";

import appRouters from "../views/AppViews/routers"

import { getConfig } from "../utils/config";

const config = getConfig()


export default function AppRouters(props) {
  return <Switch>
    {
      appRouters.map((router, idx) => {
        if(config.menu.excludePaths.includes(router.path)){

        }else{
        return <Route
          key={`app-router-${idx}`}
          path={router.path}
          exact={true}
          component={router.component} />
        }
      })
    }
  </Switch>
}

export function PublicRouters() {

  const location = useLocation();

  const RedirectWithQuery = () => {
    const path = location.pathname === '/register' ? '/register' : '/login';
    return <Redirect to={`${path}${location.search}`} />;
  };

  return (
    <Switch>
      <Route exact={true} path="/login" component={NewLogin} />
      <Route exact={true} path="/register" component={Register} />
      <Route exact={true} path="/reset-password/" component={ForgotPassword} />
      <Route exact={true} path="/reset-password/:id" component={ForgotPassword} />
      <Route exact path="/maintenance" component={Maintenance} />
      <Route path="*" component={RedirectWithQuery} />
    </Switch>
  );
}

export function AccountantRouters() {
  return (
    <Switch>
      <Route exact={true} path="/accountant" component={HomeAccountant} />
      <Route
        exact={true}
        path="/accountant/clients/register"
        component={RegisterCertificateAccountant}
      />
      <Route
        exact={true}
        path="/accountant/clients/list"
        component={listClientsAccountant}
      />
      <Route
        exact={true}
        path="/accountant/client/:id"
        component={EditClientsAccountant}
      />
      <Redirect from="*" to="/accountant" component={HomeAccountant} />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/routers/index.jsx